import { useState, useCallback } from 'react';
import dynamic from 'next/dynamic';
import Play from '@/components/ui/icons/Play';
import { useAppContext } from '@/components/utilities/AppContext';

// Dynamic import keeps react-youtube out of the initial bundle — the iframe only mounts
// after the user clicks the play button, which massively reduces TBT/INP on pages with videos.
const YouTube = dynamic(() => import('react-youtube'), { ssr: false });

const VideoBlock = ({ videoId, thumbnail }) => {
  const { locale } = useAppContext();
  const [isActivated, setIsActivated] = useState(false);

  const onPlay = useCallback(() => {
    setIsActivated(true);
  }, []);

  return (
    <div className="relative flex h-full w-full items-center justify-center overflow-hidden rounded-2xl bg-black/5">
      {isActivated ? (
        <YouTube
          videoId={videoId}
          opts={{
            width: '100%',
            height: '100%',
            playerVars: {
              controls: 1,
              modestbranding: 1,
              autoplay: 1
            }
          }}
          className="h-full w-full"
          iframeClassName="h-full w-full"
        />
      ) : (
        <button
          type="button"
          onClick={onPlay}
          aria-label={locale !== 'pl' ? 'Přehrát video' : 'Odtwórz wideo'}
          className="group absolute h-full w-full cursor-pointer"
        >
          {thumbnail}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transition-opacity">
            <div className="bg-brand-400 group-hover:bg-brand-500 ease flex h-20 w-20 scale-75 items-center justify-center rounded-full text-white shadow-[0_25.691px_44.042px_9.175px_rgba(254,64,17,0.15),5.505px_7.34px_20.186px_0_rgba(254,64,17,0.20)] transition duration-300 xl:scale-100 xl:group-hover:scale-105">
              <Play width={42} height={42} />
            </div>
          </div>
        </button>
      )}
    </div>
  );
};
export default VideoBlock;
